var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSticker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 13.8948C25.2 13.843 25.1659 13.6239 24.8628 13.3552L14.7237 4.36454C13.3808 3.17396 12.0583 2.8171 11.0924 3.07574C6.31429 4.35533 2.8 8.71816 2.8 13.8948C2.8 20.0803 7.81441 25.0948 14 25.0948V27.8948C6.26801 27.8948 0 21.6267 0 13.8948C0 7.62133 4.12618 2.3124 9.81276 0.532773L10.3687 0.372356C12.5935 -0.223376 14.8579 0.74208 16.5812 2.27001L26.7203 11.2606C27.4841 11.938 28 12.8739 28 13.8948C28 21.6267 21.732 27.8948 14 27.8948V25.0948C20.1856 25.0948 25.2 20.0803 25.2 13.8948Z",
    fill: "#253FF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.725 11.2629C27.4871 11.9385 28 12.8727 28 13.8911C28 14.1105 27.9918 14.3286 27.9818 14.5455C27.0826 14.7268 26.1526 14.8244 25.2 14.8244C17.468 14.8244 11.2 8.55643 11.2 0.82444C11.2 0.604448 11.2064 0.385701 11.2164 0.16819C11.4722 0.116585 11.7305 0.0722122 11.9911 0.0351248C13.213 -0.138746 14.4125 0.347702 15.336 1.16643L26.725 11.2629Z",
    fill: "#253FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/sticker.ca02fa8c5605d80874ee11c12fd55886.svg";
export { ForwardRef as ReactComponent };